import { PortalSettings } from '@servicetitan/cp-ui';
import { BrandData } from 'api/src/portal-branding.api';

// The BU phone is not used: it is stored per tenant region, which the client cannot see.
export const getMfePortalSettings = (
    settings: PortalSettings | undefined,
    brand: BrandData | undefined,
    authorized: boolean
): PortalSettings | undefined => {
    const name = authorized ? undefined : brand?.officialName?.trim();
    return settings && name ? { ...settings, title: name } : settings;
};
